import PropTypes from "prop-types";
import { useState } from "react";
import {
  Box,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  TablePagination,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Alert,
  Button,
} from "@mui/material";
import { DelAPI } from "../../Components/Backend/DelAPI";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import APIAxios from "../../Api/APIAxios";
import SessaoAuth from "../../Hooks/SessaoAuth";

const URL_SERVICE = "/perfil";

const PerfisTabela = ({ perfis, setPerfis }) => {
  const { sessao, setSessao } = SessaoAuth();
  const setRowsPerPage = (newRowsPerPage) => {
    setSessao((prev) => ({ ...prev, rowsPerPage: newRowsPerPage }));
  };

  const apiAxios = APIAxios();

  const [orderBy, setOrderBy] = useState("perfil");
  const [order, setOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const [openExcluir, setOpenExcluir] = useState(false);
  const [sucessoAviso, setSucessoAviso] = useState(false);
  const [erroAviso, setErroAviso] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selPerfil, setSelPerfil] = useState(null);
  const Navigate = useNavigate();

  // Função para ordenar os dados
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...perfis].sort((a, b) => {
    const valA = a[orderBy] ?? "";
    const valB = b[orderBy] ?? "";

    if (valA < valB) return order === "asc" ? -1 : 1;
    if (valA > valB) return order === "asc" ? 1 : -1;
    return 0;
  });

  const paginatedData = sortedData.slice(
    page * (sessao.rowsPerPage || 10),
    page * (sessao.rowsPerPage || 10) + (sessao.rowsPerPage || 10)
  );

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Função para editar usuário
  const handleEditar = (e, perfil) => {
    Navigate(`/perfis/${perfil.id}`);
  };

  const handleClickOpenExcluir = (e, profile) => {
    setSelPerfil(profile);
    setOpenExcluir(true);
  };

  const handleClickCloseExcluir = () => {
    setOpenExcluir(false);
  };

  const handleCloseAviso = (event, reason) => {
    if (reason === "clickaway") return;
    setErroAviso(false);
    setSucessoAviso(false);
  };

  const excluirPerfil = async () => {
    setLoading(true);
    setOpenExcluir(false);
    setErroAviso(false);
    setSucessoAviso(false);

    const response = await DelAPI(apiAxios, `${URL_SERVICE}/${selPerfil.id}`);

    if (response.success) {
      // Remove o item da lista sem recarregar a página
      setPerfis((prev) =>
        prev.filter((profile) => profile.id !== selPerfil.id)
      );
      setSucessoAviso(true);
    } else {
      setErroAviso(true);
    }

    setLoading(false);
  };

    useEffect(() => {
      setPage(0);
    }, [perfis]);

  return (
    <Box>
      {/* Diálogo para Excluir Perfil */}
      <Dialog
        open={openExcluir}
        onClose={handleClickCloseExcluir}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deseja Excluir este Perfil?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Após a exclusão, o perfil não poderá ser recuperado.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickCloseExcluir}>Cancelar</Button>
          <Button onClick={excluirPerfil} autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Aviso de Exclusão com sucesso */}
      <Snackbar
        open={sucessoAviso}
        autoHideDuration={5000}
        onClose={handleCloseAviso}
        anchorOrigin={{ vertical: "top", horizontal: "center" }} // posição suspensa
      >
        <Alert
          onClose={handleCloseAviso}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Exclusão efetuada com sucesso!
        </Alert>
      </Snackbar>

      {/* Aviso de Erro de Exclusão*/}
      <Snackbar
        open={erroAviso}
        autoHideDuration={5000}
        onClose={handleCloseAviso}
        anchorOrigin={{ vertical: "top", horizontal: "center" }} // posição suspensa
      >
        <Alert
          onClose={handleCloseAviso}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Não foi possível excluir o perfil.
        </Alert>
      </Snackbar>

      <Paper sx={{ mt: 2 }} elevation={4}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sortDirection={orderBy === "nome" ? order : false}>
                  <TableSortLabel
                    active={orderBy === "nome"}
                    direction={orderBy === "nome" ? order : "asc"}
                    onClick={() => handleSort("nome")}
                  >
                    Perfil
                  </TableSortLabel>
                </TableCell>
                <TableCell>{/* Ícones */}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((profile, index) => (
                <TableRow key={index}>
                  <TableCell>{profile.nome}</TableCell>
                  <TableCell>
                    <Box
                      sx={{ display: "flex", gap: 1, justifyContent: "end" }}
                    >
                      <IconButton
                        aria-label="editar"
                        onClick={(event) => handleEditar(event, profile)}
                      >
                        <EditIcon style={{ color: "#1a3865" }} />
                      </IconButton>
                      <IconButton
                        aria-label="deletar"
                        onClick={(event) =>
                          handleClickOpenExcluir(event, profile)
                        }
                      >
                        <DeleteIcon style={{ color: "#f4793c" }} />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={perfis.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={sessao.rowsPerPage || 10}
          labelRowsPerPage="Linhas por página"
          rowsPerPageOptions={[5, 10, 25]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          justifyContent="bottom"
          sx={{
            "& .MuiTablePagination-toolbar": {
              alignItems: "center",
            },
            "& p": {
              marginBottom: 0, // Remove a margem inferior do <p>
            },
          }}
        />
      </Paper>
    </Box>
  );
};

PerfisTabela.propTypes = {
  perfis: PropTypes.array.isRequired,
  setPerfis: PropTypes.func.isRequired,
};

export default PerfisTabela;
